/**
 * Shared dependencies
 */
import type { List } from '../../shared/types/lists';

/**
 * Fetches the lists associated with the current user from the Valio API.
 * @link https://evermade.stoplight.io/docs/valio-app/7s34hiyyp6bpn-get-users-user-id-lists
 * @return {Promise<List[]>} A promise that resolves to an array of user lists.
 */
export async function getUserLists(): Promise<List[]> {
	const { host } = window.valioConfig;
	const { session } = window.valioApp;

	// Ensure the session is initialized
	if (!session.initialized) {
		await session.init();
	}

	// Ensure the user is authenticated
	if (!session.userId) {
		return [];
	}

	const headers = await session.authHeader();

	return fetch(`${host}/api/v1/users/${session.userId}/lists`, {
		method: 'GET',
		headers,
	})
		.then(async (response) => {
			if (!response.ok) {
				// Handle HTTP errors like 401, 404, 500, etc.
				const errorText = await response.text();
				throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
			}

			return await response.json();
		})
		.catch((error) => {
			console.error('Error fetching user lists:', error);
			throw error;
		});
}
